import { useEffect, useRef } from "react"
import { GrFormPreviousLink } from "react-icons/gr"
import { useDispatch, useSelector } from "react-redux"
import { useLocation, useSearchParams } from "react-router-dom"
import { useToasts } from "react-toast-notifications"
import MenuBar from "../Components/default-components/Menu/MenuBar"
import { logOut } from "../Reducers/default-reducers/globalConfigReducer"
import AcessoNaoPermitido from "../Screens/AcessoNaoPermitido"
import { buildPageTitle } from "../Services/default/stringUtils"
import useLogin from "../hooks/defaults/useLogin"
import useNavigator from "../hooks/defaults/useNavigator"

export const withMenuBar = (Component) => {
	const WithMenuBar = (props) => {
		const toast = useToasts()
		const history = useNavigator()
		const global = useSelector((state) => state.global)
		const unreadNotificationsNum = useSelector((state) => state.notification.unreadCount)
		const pageLocation = global.pageLocation
		const userId = global.userId
		const isAuth = global.isAuth
		
		let prps = { pageLocation, toast, userId, ...props }
		const dispatch = useDispatch()
		const { pathname } = useLocation()
		const [searchParams] = useSearchParams()
		const avoidLocations = ["/Login", "/"]
		const {authHandler}  = useLogin()
		const tokenProcessedRef = useRef(false)

		// Verifica se há token na URL (vindo de outro app)
		useEffect(() => {
			const tokenFromUrl = searchParams.get('token')
			// Se já processamos o token, ou não existe token, ou já está autenticado, não fazer nada
			if (!tokenFromUrl || isAuth || tokenProcessedRef.current) return

			// marca como processado para evitar reentrância
			tokenProcessedRef.current = true

			const loginFromToken = async (token) => {
				// Decodifica o token que vem em base64
				const decodedToken = atob(token)
				try {

					await authHandler({}, decodedToken)

					toast.addToast('Login automático realizado com sucesso', { appearance: 'success', autoDismiss: true })
				} catch (error) {
					console.error('Erro ao processar token da URL:', error)
					toast.addToast('Erro ao processar login automático', { appearance: 'error' , autoDismiss: true })
				} finally {
					// Remove o token da URL para maior segurança
					const url = new URL(window.location)
					url.searchParams.delete('token')
					window.history.replaceState({}, document.title, url.pathname + url.search)
				}
			}

			loginFromToken(tokenFromUrl)

		}, [searchParams, isAuth])
		
		useEffect(() => {
			document.title = buildPageTitle(pathname, unreadNotificationsNum)
		},[pathname, unreadNotificationsNum])
		
		const validateLocation = () => {
			if (isAuth && !global.role) dispatch(logOut())
			if (avoidLocations.includes(pathname)) return true
			if (isAuth && global?.role) {
				const currentUserFrontEndPerms =
					global?.role?.permissao[0].frontEndPerms

				const filteredPerm = currentUserFrontEndPerms.find((cUFEP) => {
					let filteredLocation = `/${cUFEP.locationBloqueado}`
					return filteredLocation == pathname
				})
				if (filteredPerm) {
					if (filteredPerm.componentesBloqueados.length > 0) {
						return true
					} else return false
				} else return true
			}
			return true
		}
		
		return (
			<>
				
				<MenuBar/>
				
					{isAuth && (
						<GrFormPreviousLink
							className="prev_button"
							onClick={() => history(-1)}
							style={{ marginLeft: "1%" }}
							size={40}
						/>
					)}
					<div style={{marginLeft: '5%', marginRight: "5%"}}>

					<>
						{/* {pathname != paths.acessoNaoPermitido ? (
							<h2 style={{ textAlign: "center" }}>
								{" "}
								{pathToHeader(pathname)}
							</h2>
						) : (
							""
						)} */}
						{validateLocation() ? (
							<Component {...prps} />
							
						) : (
							<AcessoNaoPermitido />
						)}
					</>
					</div>

			</>
		)
	}
	return WithMenuBar
}
